import { datadogRum } from "@datadog/browser-rum";
import { useContext, useEffect } from "react";

import { AppDefaultInfoContext } from "helpers/globalContext/AppDefaultInfoContext";

/**
 * Force-records Session Replay once a user opens AI search. A Datadog retention filter can't do
 * this: replay sampling is decided in the browser, and a filter can only keep what was recorded.
 * Safe on every open, since the SDK ignores a start while already recording.
 */
export function useForceSearchReplay() {
    const isEnabled = useContext(AppDefaultInfoContext)?.dataDogForceAiSearchReplay === true;

    useEffect(() => {
        if (!isEnabled || !datadogRum.getInitConfiguration()) {
            return;
        }

        datadogRum.startSessionReplayRecording({ force: true });
    }, [isEnabled]);
}
